import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import id from "@irati/utils/id"
import {injectIntl, FormattedMessage} from "@irati/utils/lang"
import padding from "@irati/ui/src/global/padding"
import {H3} from "@irati/ui/src/Typography/Heading"
import Button from "@irati/ui/src/Button"
import ohsnap from "@irati/ui/images/oh_snap_2.svg"

const Container = styled.div`
  margin: ${padding.base} 0 0 0;
`

const SearchError = (props) => {
  const {retryLastSearch} = props
  const idNamespace = id("search-error", props)
  return (
    <Container id={idNamespace} className="center">
      <img id={id("img", idNamespace)} src={ohsnap} alt={props.formatMessage({id: "perks.containers.searchAll.searchError.alt"})} />
      <H3 id={id("title", idNamespace)}>
        <FormattedMessage id="perks.containers.searchAll.searchError.heading" />
      </H3>
      <p id={id("body", idNamespace)}>
        <FormattedMessage id="perks.containers.searchAll.searchError.errorMessage" />
      </p>
      <Button id={id("btn", idNamespace)} onClick={() => retryLastSearch()}>
        <FormattedMessage id="perks.container.searchAll.searchError.cta" />
      </Button>
    </Container>
  )
}

SearchError.propTypes = {
  retryLastSearch: PropTypes.func,
  formatMessage: PropTypes.func.isRequired
}
SearchError.defaultProps = {
  retryLastSearch: () => {}
}

export default injectIntl(SearchError)
